import { useInView } from 'react-intersection-observer';
import Calendar from '@/v2/components/Calendar/Calendar';
import { SpecialistInfoCard } from '@/v2/components/SpecialistInfoCard/SpecialistInfoCard';
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import { useHistory } from 'react-router-dom';
import ExpressCareDialog from '@/v2/pages/ServicesPage/Components/ExpressCareDialog';
import SgkDialog from '@/v2/pages/ServicesPage/Components/SgkDialog';
import { useCartData } from '@/v2/pages/CartPage/context/CartDataContext';
import useFetch from 'use-http';
import LabAdditionalRegistrationDialog from '@/v2/pages/ServicesPage/Components/LabAdditionalRegistrationDialog';
import LabServiceSelect from './LabServiceSelect';
import EmptyCalendar from './EmptyCalendar';
import ExpressCareDialogInformation from '@/v2/pages/ServicesPage/Components/ExpressCareDialogInformation';
import {
  is3TWorkplace,
  isConsultationByServiceTypeExtId,
  isMrt,
  isSGBySpecialty,
} from '@/v2/utils/commonServiceClassificationRulesUtils';
import TimeslotReservationErrorDialog from '@/v2/pages/ServicesPage/Components/TimeslotReservationErrorDialog';
import ServiceQueueUserInformationDialog from '@/v2/pages/ServicesPage/Components/ServiceQueueUserInformationDialog';
import { useUserState } from '@/components/context/UserContext';
import {
  pushExponeaBookingStartEvent,
  pushServiceSelectionEvents,
} from '@/v2/utils/bookingTracking';
export function SpecialistInfoCardWithCalendar({
  service,
  visitPaymentTypeFilter,
  ...rest
}) {
  const isPsdfFilterSelected = String(visitPaymentTypeFilter) === '2';
  const calendarDate = isPsdfFilterSelected
    ? service.nearestPsdfDate
    : service.upcomingVisit;
  const hasCalendarSlots = Boolean(calendarDate);
  const { request: timeRequest } = useFetch(`/TimeSlots`);
  const history = useHistory();
  const userState = useUserState();
  const {
    services,
    setServices,
    selectedTimeSlot,
    setSelectedTimeSlot,
    setAdditionalServices,
    setLoading,
    addingMoreServices,
    setAddingMoreServices,
    setAddingMorePsdfServices,
  } = useCartData();

  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  const [selectedSlot, setSelectedSlot] = useState();
  const SGSpecialtyExternalId = process.env.REACT_APP_SG_SPECIALTY_EXTERNAL_ID;
  const expressCareExternalId =
    process.env.REACT_APP_EXPRESS_CARE_SERVICE_TYPE_EXT_ID;
  const GSKServiceTypeExternalId =
    process.env.REACT_APP_GSK_SERVICE_TYPE_EXT_ID;
  const VGSKServiceTypeExternalId =
    process.env.REACT_APP_VGSK_SERVICE_TYPE_EXT_ID;
  const gastroenterologyServiceTypeExternalId =
    process.env.REACT_APP_GASTROENTEROLOGY_SERVICE_TYPE_EXTERNAL_ID;

  const familyDoctorsExternalId =
    process.env.REACT_APP_SGKN_SERVICE_TYPE_EXT_ID;

  const labServiceTypeExternalId = process.env.REACT_APP_LABEXTERNALID;
  const isFamilyDoctorGroup =
    service.serviceTypeExternalId == familyDoctorsExternalId;
  const [expressCareDialogOpen, setExpressCareDialogOpen] = useState(false);
  const [
    expressCareInformationDialogOpen,
    setExpressCareInformationDialogOpen,
  ] = useState(false);
  const [sgkDialogOpen, setSgkDialogOpen] = useState(false);
  const [addToQueueDialogOpen, setAddToQueueDialogOpen] = useState(false);
  const [pendingValues, setPendingValues] = useState(null);
  const [loadingSlot, setLoadingSlot] = useState(null);
  const [addMoreLabDialogOpen, setAddMoreLabDialogOpen] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const { request: serviceRequest, response: serviceGetResponse } =
    useFetch('/Services');
  const [
    timeslotReservationErrorDialogOpen,
    setTimeslotReservationErrorDialogOpen,
  ] = useState(false);
  const {
    request: mandotaryServiceRequest,
    response: mandotaryServiceGetResponse,
  } = useFetch('/Services/GetMandotaryServices');

  const {
    request: additionalServicesRequest,
    response: AdditionalServicesGetResponse,
  } = useFetch('/Services/AdditionalServices');

  const handleProceed = async (type) => {
    setLoadingSlot(true);
    await acceptSgkDialog().then(() => {
      setLoadingSlot(true);
      if (type) {
        history.push(`/cart/${service.workplaceId}/${service.serviceId}`);
      }
    });
  };

  const isGastroServiceType = () => {
    if (!service || !service.serviceTypeExternalId) {
      return false;
    }
    return (
      gastroenterologyServiceTypeExternalId == service.serviceTypeExternalId
    );
  };

  // useEffect(() => {
  //     async function fetchData() {
  //       await postOtherServices('', {
  //         serviceId: serviceId,
  //         workplaceId: workplaceId,
  //       }).then((res) => {
  //         setOtherServices(res);
  //       });
  //     }
  //     fetchData();
  //   }, []);
  const LANGUAGE_MAP = {
    LT: 'Lietuvių',
    EN: 'Anglų',
    RU: 'Rusų',
  };

  const formatLanguages = (languages) => {
    if (!Array.isArray(languages) || languages.length === 0) {
      return '-';
    }

    return languages.map((code) => LANGUAGE_MAP[code] || code).join(', ');
  };

  const expandDataWithAdditionalServices = (timeSlot) => {
    if (isGastroServiceType()) {
      if (!!timeSlot && !!timeSlot.researchAreaId && timeSlot.isPaid) {
        const params = new URLSearchParams({
          serviceId: service.serviceId,
          researchAreaId: timeSlot.researchAreaId,
          timeSlotDateTime: timeSlot.startDate,
          departmentExternalId: service.departmentExternalId,
        });
        const url = `ResearchAreaDayOfWeekAdditionalServices?${params.toString()}`;
        serviceRequest.get(url).then((response) => {
          setAdditionalServices((prev) => [
            ...prev,
            ...response,
            ...(service.mandatoryOtherServices ?? []),
          ]);
        });
      }
    }
  };

  const getMandotaryServices = (timeSlot) => {
    if (timeSlot?.isPaid && isGastroServiceType()) {
      mandotaryServiceRequest
        .get(
          `?serviceId=${service.serviceId}&workplaceId=${service.workplaceId}`,
        )
        .then((res) => {
          setAdditionalServices((prev) => [...prev, ...(res ?? [])]);
        });
    }
  };

  const getAdditionalServices = (timeslot, workplaceId, serviceId) => {
    if (
      (is3TWorkplace(service?.workplaceExternalId) && !timeslot.isPaid) ||
      (!is3TWorkplace(service?.workplaceExternalId) &&
        !isMrt(service?.serviceTypeExternalId) &&
        timeslot.isPaid)
    ) {
      additionalServicesRequest
        .get(`${workplaceId}/${serviceId}`)
        .then((res) => {
          setAdditionalServices((prev) => {
            const existingIds = new Set(prev.map((s) => s.serviceId));
            const newItems = (res ?? []).filter(
              (s) => !existingIds.has(s.serviceId),
            );
            return [...prev, ...newItems];
          });
        });
    }
  };

  const acceptSgkDialog = async (redirect) => {
    setPendingValues(selectedTimeSlot);
    getMandotaryServices(selectedTimeSlot);
    getAdditionalServices(
      selectedTimeSlot,
      service.workplaceId,
      service.serviceId,
    );
    expandDataWithAdditionalServices(selectedTimeSlot);
    await timeRequest
      .put('/Reservation', {
        timeSlotsIds: [selectedTimeSlot.timeSlotId],
        additionalData: `triggeredAt:useTimeslotApi.js extendTime; historyLocation:${history.location.pathname}`,
      })
      .then(() => {
        pushServiceSelectionEvents({
          service,
          selectedTimeSlot,
        });
        pushExponeaBookingStartEvent({
          service,
          selectedTimeSlot,
        });

        if (redirect) {
          history.push(`/cart`);
        }
      });
  };

  const hasServicePotentialyIncresedPrice = (service) => {
    const extraPrice = Number(service?.extraPrice);
    const inceasedPriceForServiceType =
      service?.serviceTypeExternalId == GSKServiceTypeExternalId ||
      service?.serviceTypeExternalId == VGSKServiceTypeExternalId;
    return (
      (!is3TWorkplace(service?.workplaceExternalId) &&
        service?.hasPotentialForIncreasedPrice) ||
      (Number.isFinite(extraPrice) && extraPrice > 0) ||
      inceasedPriceForServiceType
    );
  };

  const showQueue = service.upcomingVisit === null && service.showInQueue;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 w-full" ref={ref}>
      <SpecialistInfoCard
        visitPaymentType={visitPaymentTypeFilter}
        name={
          service.specialistId ? service.specialistName : service.serviceTitle
        }
        specialty={service.cardTitle}
        address={service.departmentTitle}
        defaultServiceId="consultation"
        specialistId={service.specialistId}
        specialistUrl={service.serviceLink}
        sgk={service?.specialtyExternalId == SGSpecialtyExternalId}
        serviceTitle={service.specialistId ? service.serviceTitle : ''}
        services={[
          { id: 'consultation', label: 'Gydytojo konsultacija' },
          {
            id: 'remote-consultation',
            label: 'Nuotolinė gydytojo konsultacija',
          },
        ]}
        infoItems={[
          {
            label: 'Galima PSDF kompensacija',
            value: service.psdf ? 'Taip' : 'Ne',
            align: 'left',
          },
          {
            label: 'Kalbos',
            value: formatLanguages(service.languages),
            align: 'left',
          },
          {
            label: hasServicePotentialyIncresedPrice(service)
              ? 'Kaina nuo'
              : 'Kaina',
            value: (
              <div className="flex flex-wrap justify-end gap-x-2 gap-y-0.5">
                <span className="whitespace-nowrap">
                  {service.hasPriceFromConfigured ? 'nuo ' : ''}
                  {service.priceWithDiscount} €
                </span>
                {Number.isFinite(service.price) &&
                  Number.isFinite(service.priceWithDiscount) &&
                  service.price > service.priceWithDiscount &&
                  service.price > 0 && (
                    <span className="text-gray-400 line-through whitespace-nowrap">
                      {service.price} €
                    </span>
                  )}
              </div>
            ),
            align: 'right',
          },
        ]}
        categoryId={3}
        backUrl={rest.urlParams}
        noRegistrationService={false}
        complexPrices={service.prices}
        selectedFilterDepartment={rest.selectedDepartmentFilter}
        isDisabled={rest.laboratoryMultipleServicePayload?.laboratoryMultipleServices.some(
          (labService) => labService.serviceId == service.serviceId,
        )}
        addToMultipleServicesCallback={
          !!rest.isLaboratoryMultipleServices
            ? () => rest.addToMultipleLaboratoryServicesCallback(service)
            : undefined
        }
      />
      {inView && (
        <>
          {addingMoreServices && !isFamilyDoctorGroup && (
            <LabServiceSelect
              containsService={services.some(
                (s) => s.serviceId === service.serviceId,
              )}
              onRegister={() => {
                setServices((prevServices) => {
                  if (
                    prevServices.some((s) => s.serviceId === service.serviceId)
                  ) {
                    return prevServices.filter(
                      (s) => s.serviceId !== service.serviceId,
                    );
                  }

                  const updated = [...prevServices, service];
                  getAdditionalServices(
                    selectedTimeSlot,
                    service.workplaceId,
                    service.serviceId,
                  );
                  return updated;
                });
              }}
            />
          )}

          {!addingMoreServices && isFamilyDoctorGroup && (
            <EmptyCalendar></EmptyCalendar>
          )}
          {!addingMoreServices && !isFamilyDoctorGroup && (
            <Calendar
              hasSlots={hasCalendarSlots}
              workplaceId={service.workplaceId}
              service={service}
              visitPaymentTypeFilter={visitPaymentTypeFilter}
              widget={false}
              stopLoading={loadingSlot}
              dataRequest={(from, to, filter) =>
                rest.getTimeSlots(
                  from,
                  to,
                  filter,
                  service.workplaceId,
                  service.serviceId,
                )
              }
              filter={calendarDate}
              psdfService={service.psdf}
              hasNearestPsdfDate={service.nearestPsdfDate !== null}
              extraPrice={service.extraPrice}
              servicePrice={service.priceWithDiscount}
              showQueue={showQueue}
              selected={
                selectedSlot?.duplicatedTimeSlotId === null
                  ? selectedSlot?.timeSlotId
                  : selectedSlot?.duplicatedTimeSlotId
              }
              onChange={(timeSlot) => {
                if (labServiceTypeExternalId == service.serviceTypeExternalId) {
                  setAddMoreLabDialogOpen(true);
                  setLoadingSlot(true);
                  setSelectedTimeSlot(timeSlot);
                  setServices([service]);
                } else if (
                  expressCareExternalId == service.serviceTypeExternalId
                ) {
                  setExpressCareInformationDialogOpen(true);
                  setSelectedTimeSlot(timeSlot);
                  setServices([service]);
                  setLoadingSlot(true);
                } else if (
                  isSGBySpecialty(service?.specialtyExternalId) &&
                  isConsultationByServiceTypeExtId(
                    service?.serviceTypeExternalId,
                  ) &&
                  service.psdf &&
                  service.nearestPsdfDate &&
                  timeSlot?.isPaid
                ) {
                  setLoadingSlot(true);
                  setSgkDialogOpen(true);
                  setSelectedTimeSlot(timeSlot);
                  setServices([service]);
                } else {
                  setSelectedTimeSlot(timeSlot);
                  setServices([service]);
                  setPendingValues(timeSlot);
                  getMandotaryServices(timeSlot);
                  getAdditionalServices(
                    timeSlot,
                    service.workplaceId,
                    service.serviceId,
                  );
                  expandDataWithAdditionalServices(timeSlot);

                  timeRequest
                    .post('/Reservation', {
                      timeSlotsIds: [timeSlot.timeSlotId],
                      additionalData: `triggeredAt:useTimeslotApi.js extendTime; historyLocation:${history.location.pathname}`,
                    })
                    .then((res) => {
                      if (res.status >= 400) {
                        setTimeslotReservationErrorDialogOpen(true);
                        return;
                      }

                      pushServiceSelectionEvents({
                        service,
                        selectedTimeSlot: timeSlot,
                      });
                      pushExponeaBookingStartEvent({
                        service,
                        selectedTimeSlot: timeSlot,
                      });

                      history.push('/cart');
                    })
                    .catch(() => {
                      setTimeslotReservationErrorDialogOpen(true);
                    });
                }
              }}
            />
          )}
        </>
      )}

      <ExpressCareDialog
        open={expressCareDialogOpen}
        onOpenChange={() => {
          setLoadingSlot(false);
          setExpressCareDialogOpen(false);
        }}
        onProceed={(type) => handleProceed(type)}
      />

      <ExpressCareDialogInformation
        open={expressCareInformationDialogOpen}
        onOpenChange={() => {
          setLoadingSlot(false);
          setExpressCareInformationDialogOpen(false);
        }}
        onProceed={() => {
          setExpressCareInformationDialogOpen(false);
          setExpressCareDialogOpen(true);
        }}
      />

      <LabAdditionalRegistrationDialog
        open={addMoreLabDialogOpen}
        loadingButton={loadingButton}
        selectedSlotTime={
          selectedTimeSlot
            ? new Date(selectedTimeSlot.startDate).toLocaleString('lt-LT', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
              })
            : null
        }
        onOpenChange={(decline) => {
          setAddMoreLabDialogOpen(decline);
          setLoadingSlot(false);
        }}
        onAccept={async (accept) => {
          if (accept) {
            setLoadingButton(true);
            await acceptSgkDialog(true);
            setLoadingButton(false);
            return true;
          }
          return false;
        }}
        onAddMore={async (addMore) => {
          if (addMore) {
            setLoadingButton(true);
            await acceptSgkDialog(false);
            setAddingMoreServices(true);
            if (!selectedTimeSlot.isPaid) {
              setAddingMorePsdfServices(true);
            }
            setLoadingButton(false);
            return true;
          }
          return false;
        }}
      />

      <SgkDialog
        open={sgkDialogOpen}
        onOpenChange={(decline) => {
          setSgkDialogOpen(decline);
          setLoadingSlot(false);
        }}
        onAccept={async (accept) => {
          if (accept) {
            await acceptSgkDialog(true);
          }
        }}
      />

      <TimeslotReservationErrorDialog
        open={timeslotReservationErrorDialogOpen}
        onOpenChange={(decline) => {
          setTimeslotReservationErrorDialogOpen(decline);
          setLoadingSlot(false);
        }}
      />

      <ServiceQueueUserInformationDialog
        open={addToQueueDialogOpen}
        onOpenChange={setAddToQueueDialogOpen}
        initialPhoneNumber={userState?.phoneNumber || ''}
        initialEmail={userState?.email || ''}
        initialName={userState?.firstName || ''}
        initialSurname={userState?.lastName || ''}
        initialPersonalCode={userState?.personalCode || ''}
        serviceId={service.serviceId}
        workplaceId={service.workplaceId}
        onAccept={(data) => {
          // logged in -> data === true
          // not logged in -> data = { phoneNumber, email }
        }}
      />
    </div>
  );
}
